import * as React from 'react';
import Dialog from 'src/components/common/Dialog';
import DialogList from 'src/dialogs';
import Button from 'src/components/controls/forms/redesign/FormButton';
import FormSelect from 'src/components/controls/forms/redesign/FormFilterSelect';
import Form from 'src/components/controls/forms/Form';
import { AnyObject } from 'final-form';
import FormTextBox from 'src/components/controls/forms/redesign/FormTextbox';
import { ODataOptions, ODataFilter, ODataFilterOperators } from 'src/util/ODataBuilder';

export interface IOwnerListFilter {
    applyFilter: (pageNumber: number, pagingOptions?: ODataOptions) => void;
}

class OwnerListFilter extends React.Component<IOwnerListFilter> {
    onSubmit = (values: AnyObject) => {
        console.log('filter values', values);

        const options = new ODataOptions();
        const filter1 = new ODataFilter('OwnerType', ODataFilterOperators.Equals, values.ownerTypeSelect);
        if (values.interestModifier === 1) {
            const filter2 = new ODataFilter('InterestRange', ODataFilterOperators.GreaterThanOrEqual, values.interestValue);
            options.addFilter(filter2);
        } else {
            const filter2 = new ODataFilter('InterestRange', ODataFilterOperators.LessThanOrEqual, values.interestValue);
            options.addFilter(filter2);
        }

        // TODO get page size from table config
        options.addPaging(1, 5);
        options.addFilter(filter1);

        console.log('options', options);

        this.props.applyFilter(1, options);
    };

    render() {
        return (
            <Dialog dialogName={DialogList.OWNER_LIST_FILTER} title="Filter This You Casual">
                <Form onSubmit={this.onSubmit}>
                    <div>
                        <div>
                            <div style={{ display: 'inline-block' }}>Owner Type</div>
                            <div style={{ display: 'inline-block' }}>
                                <FormSelect
                                    name="ownerTypeSelect"
                                    items={[
                                        { id: 1, name: 'Individual' },
                                        { id: 2, name: 'Business' },
                                    ]}
                                />
                            </div>
                        </div>

                        <div>
                            <div style={{ display: 'inline-block', width: '20%' }}>Interest</div>
                            <div style={{ display: 'inline-block', width: '35%' }}>
                                <FormSelect
                                    name="interestModifier"
                                    items={[
                                        { id: 1, name: 'Greater Than' },
                                        { id: 2, name: 'Less Than' },
                                    ]}
                                />
                            </div>
                            <div style={{ display: 'inline-block', width: '20%', marginLeft: '.7rem' }}>
                                <FormTextBox name="interestValue" label="Value" />
                            </div>
                        </div>
                    </div>
                    <div style={{ borderTop: '.1rem solid darkgrey', marginTop: '.7rem' }}>
                        Current filter: Interest Greater than 50%, sorted by owner name
                    </div>
                    <div style={{ textAlign: 'right', marginTop: '1rem' }}>
                        <Button text="APPLY FILTER" intent="primary" size="medium" type="submit" />
                    </div>
                </Form>
            </Dialog>
        );
    }
}

export default OwnerListFilter;



// WEBPACK FOOTER //
// ./src/components/project/sections/TractComponents/OwnerListFilter.tsx